module.exports = __webpack_public_path__ + "static/img/collapse.8c9e9b18.svg";